export default __webpack_public_path__ + "static/media/LANL.f09dd48c.png";